// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"25":"d2f1fbba","481":"2889fc89","556":"9d82e906","560":"2889fc89"}[chunkId] + ".css";
};